module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_023.png
// module id = 2339
// module chunks = 5